var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home-saude"}},[_c('v-container',[_c('v-card',{staticClass:"py-4 px-1",attrs:{"tile":""}},[_c('page-title',{attrs:{"main":"Painel","icon":"mdi-pencil-box-outline","sub":"Gestão Saúde","home":"/"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }